import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
	ChevronLeft,
	ChevronDown,
	ChevronRight,
	Calendar,
	TestTube,
	Zap,
} from "lucide-react";
import axios from "axios";
import { TiTick } from "react-icons/ti";

import { baseUrl } from "../utils/OtherUtils";

import { FaXTwitter } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa6";
import { useAuthContext } from "../context/AuthContext";
import { useTestContext } from "../context/TestContext";
import { useOrderProcessingContext } from "../context/OrderProcessingContext";

export default function BlogFullRightSide() {
	const { handleTC } = useAuthContext();
	const [formData, setFormData] = useState({
		name: "",
		mobile: "",
		agreed: true,
	});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isSubmitted, setIsSubmitted] = useState(false);

	const [selectedCategory, setSelectedCategory] = useState("");
	const [categoryDropdown, setCategoryDropdown] = useState(false);
	const [popularPosts, setPopularPosts] = useState([]);

	const [currentSlide, setCurrentSlide] = useState(0);
	const [isAutoPlaying, setIsAutoPlaying] = useState(true);

	// Sample checkup data
	// const checkups = [
	// 	{
	// 		id: 1,
	// 		title: "One Plus One Healthy India 2025 Full Body Checkup Advance",
	// 		totalTests: 85,
	// 		testsIncluded:
	// 			"Blood Glucose Fasting, Vitamin B12 Cyanocobalamin, Vitamin D Total-25 Hydroxy, Liver Function Test, Thyroid Profile-Total (T3, T4 & TSH Ultra-sensitive)",
	// 		currentPrice: 1325,
	// 		originalPrice: 3155,
	// 		discount: 58,
	// 		popular: true,
	// 	},
	// 	{
	// 		id: 2,
	// 		title: "Complete Health Checkup Premium Package 2025",
	// 		totalTests: 72,
	// 		testsIncluded:
	// 			"Complete Blood Count, Lipid Profile, Kidney Function Test, Diabetes Panel, Heart Health Assessment, Cancer Markers",
	// 		currentPrice: 1599,
	// 		originalPrice: 2999,
	// 		discount: 47,
	// 		popular: false,
	// 	},
	// 	{
	// 		id: 3,
	// 		title: "Executive Health Screening Comprehensive",
	// 		totalTests: 95,
	// 		testsIncluded:
	// 			"Advanced Cardiac Profile, Tumor Markers, Hormonal Analysis, Nutritional Assessment, Bone Health Profile, Metabolic Panel",
	// 		currentPrice: 2199,
	// 		originalPrice: 4200,
	// 		discount: 48,
	// 		popular: false,
	// 	},
	// 	{
	// 		id: 4,
	// 		title: "Young Professional Health Package",
	// 		totalTests: 65,
	// 		testsIncluded:
	// 			"Stress Markers, Vitamin Profile, Basic Metabolic Panel, Immunity Check, Lifestyle Disease Screening",
	// 		currentPrice: 999,
	// 		originalPrice: 1899,
	// 		discount: 47,
	// 		popular: false,
	// 	},
	// 	{
	// 		id: 5,
	// 		title: "Senior Citizen Comprehensive Checkup",
	// 		totalTests: 88,
	// 		testsIncluded:
	// 			"Geriatric Panel, Bone Density, Cognitive Assessment, Cardiac Risk Evaluation, Diabetes Monitoring, Kidney Function",
	// 		currentPrice: 1799,
	// 		originalPrice: 3499,
	// 		discount: 49,
	// 		popular: false,
	// 	},
	// 	{
	// 		id: 6,
	// 		title: "Women's Wellness Complete Package",
	// 		totalTests: 78,
	// 		testsIncluded:
	// 			"Gynecological Panel, Breast Health Screening, Hormonal Balance, Iron Studies, Calcium Profile, Reproductive Health",
	// 		currentPrice: 1499,
	// 		originalPrice: 2799,
	// 		discount: 46,
	// 		popular: false,
	// 	},
	// 	{
	// 		id: 7,
	// 		title: "Men's Health Elite Screening",
	// 		totalTests: 82,
	// 		testsIncluded:
	// 			"Prostate Health, Testosterone Levels, Heart Disease Risk, Liver Function, Muscle Health, Performance Markers",
	// 		currentPrice: 1699,
	// 		originalPrice: 3199,
	// 		discount: 47,
	// 		popular: false,
	// 	},
	// 	{
	// 		id: 8,
	// 		title: "Family Health Package Deluxe",
	// 		totalTests: 91,
	// 		testsIncluded:
	// 			"Comprehensive Metabolic Panel, Infectious Disease Screening, Allergy Testing, Genetic Predisposition, Nutrition Analysis",
	// 		currentPrice: 2499,
	// 		originalPrice: 4799,
	// 		discount: 48,
	// 		popular: false,
	// 	},
	// ];

	useEffect(() => {
		fetch("/blogs.json")
			.then((res) => res.json())
			.then((data) => {
				// Sort by likes, then views, then comments (all descending)
				const sorted = [...data].sort((a, b) => {
					if (b.stats.likes !== a.stats.likes) {
						return b.stats.likes - a.stats.likes;
					}
					if (b.stats.views !== a.stats.views) {
						return b.stats.views - a.stats.views;
					}
					return b.stats.comments - a.stats.comments;
				});
				setPopularPosts(sorted.slice(0, 3));
			});
	}, []);

	// Auto-slide functionality
	useEffect(() => {
		if (isAutoPlaying) {
			const interval = setInterval(() => {
				setCurrentSlide((prev) => (prev + 1) % filteredProducts.length);
			}, 4000);
			return () => clearInterval(interval);
		}
	}, [isAutoPlaying]);

	const nextSlide = () => {
		setCurrentSlide((prev) => (prev + 1) % filteredProducts.length);
		setIsAutoPlaying(false);
	};

	const prevSlide = () => {
		setCurrentSlide(
			(prev) => (prev - 1 + filteredProducts.length) % filteredProducts.length
		);
		setIsAutoPlaying(false);
	};

	const goToSlide = (index) => {
		setCurrentSlide(index);
		setIsAutoPlaying(false);
	};

	const formatPrice = (price) => {
		return new Intl.NumberFormat("en-IN", {
			style: "currency",
			currency: "INR",
			minimumFractionDigits: 0,
		}).format(price);
	};

	const categories = [
		"All Categories",
		"Addiction Management",
		"Allergy",
		"Anemia",
		"Arthritis",
		"Asthma",
		"Blood Pressure",
		"Cancer",
		"Children's Health",
		"Coronavirus",
		"COVID-19 Diaries",
		"Deficiencies",
		"Dengue/Malaria/Chikungunya",
		"Diabetes",
		"Disease",
		"Disease Management",
		"Eye Problems",
		"FAQ Diaries",
		"Fitness",
		"Health",
		"Heart Diseases",
		"Hepatitis",
		"Hormonal Imbalance",
		"Infection/Flu/Viral",
		"Kidney",
		"Lifestyle",
		"Lifestyle & Wellness",
		"Liver",
		"Men's Health",
	];

	const socials = [
		{
			name: "X",
			text: "Follow me!",
			color: "bg-blue-500",
			icon: <FaXTwitter size={25} />,

			url: "https://x.com/LabsFine12756?t=_0qQyAiOCxlD_bgUUDMwHQ&s=09",
		},
		{
			name: "Facebook",
			text: "Follow me!",
			color: "bg-blue-600",
			icon: <FaFacebook size={25} />,
			url: "https://www.facebook.com/people/Fine-Labs/61574578554965/?rdid=kyZaCfmq3zC4oPnl&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1Bj832sqyw%2F",
		},
		{
			name: "Instagram",
			text: "Our photos!",
			color: "bg-pink-500",
			icon: <FaInstagram size={25} />, // Add your icon here
			url: "https://www.instagram.com/finelabsmarketplace?igsh=OHdzZXBpbG5sZm13&utm_source=qr",
		},
		{
			name: "Linkedin",
			text: "Visit me!",
			color: "bg-blue-700",
			icon: <FaLinkedin size={25} />, // Add your icon here
			url: "https://www.linkedin.com/company/finelabsmarketplace/",
		},
	];

	const handleCategorySelect = (category) => {
		setSelectedCategory(category);
		setCategoryDropdown(false);
	};

	const [showCoupon, setShowCoupon] = useState(false);
	const [copied, setCopied] = useState(false);

	const handleClaim = () => setShowCoupon(true);

	const handleCopy = () => {
		navigator.clipboard.writeText("FINELABS200");
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	};
	const [email, setEmail] = useState("");

	const [status, setStatus] = useState(""); // "success" | "error" | ""

	const validateEmail = (email) => {
		// Simple email regex for validation
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	};

	const { popularProducts, fetchProductsByCategories } = useTestContext();
	const { addProductToCart, order, removeProductById } =
		useOrderProcessingContext();

	const [currentPage, setCurrentPage] = useState(1);

	const filteredProducts = popularProducts
		.filter(
			(product) =>
				product.productType === "package" &&
				product.brandName === "Redcliffe Labs"
		)
		.sort((a, b) => {
			// Clean up the brandName by removing any \r and \n characters
			const cleanBrandNameA = a.brandName.replace(/[\r\n]+/g, "").trim();
			const cleanBrandNameB = b.brandName.replace(/[\r\n]+/g, "").trim();

			// First, sort by cleaned brandName in descending order
			if (cleanBrandNameB !== cleanBrandNameA) {
				return cleanBrandNameB.localeCompare(cleanBrandNameA);
			}

			// Then, if the brands are the same, sort by sellingPrice in ascending order
			const priceA = parseFloat(a.sellingPrice.replace(/,/g, "")); // Remove commas and convert to number
			const priceB = parseFloat(b.sellingPrice.replace(/,/g, "")); // Remove commas and convert to number
			return priceA - priceB; // Sort by price in ascending order
		});

	console.log("Filtered Products:", filteredProducts);

	useEffect(() => {
		fetchProductsByCategories(currentPage);
	}, [currentPage]);
	// State setup (assumed in your component)

	// Input change handler
	const handleInputChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: type === "checkbox" ? checked : value,
		}));
	};

	// Main submit handler
	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!formData.name || !formData.mobile || !formData.agreed) return;

		setIsSubmitting(true);

		try {
			await axios.post(`${baseUrl}/api/callbackRequest/add-callbackRequest`, {
				name: formData.name,
				number: formData.mobile,
			});
			setIsSubmitted(true);
			setFormData({ name: "", mobile: "", agreed: false });
		} catch (error) {
			alert("Submission failed. Please try again.");
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div className='blog-right-side'>
			{/* Health Advisor Callback Form */}
			<div className='callback-widget mt-5'>
				<h3>Get a call back from our Health Advisor</h3>
				<form onSubmit={handleSubmit} className='callback-form'>
					<div className='form-group'>
						<input
							type='tel'
							name='mobile'
							placeholder='Mobile Number*'
							value={formData.mobile}
							onChange={handleInputChange}
							required
						/>
					</div>

					<div className='form-group'>
						<input
							type='text'
							name='name'
							placeholder='Your Name'
							value={formData.name}
							onChange={handleInputChange}
							required
						/>
					</div>

					<div className='form-group checkbox-group'>
						<label className='checkbox-label'>
							<input
								type='checkbox'
								name='agreed'
								checked={formData.agreed}
								onChange={handleInputChange}
								required
							/>
							<span className='checkmark'></span>
							You hereby affirm & authorise Fine labs to process the personal
							data as per the{" "}
						</label>
						<span
							className='font-medium  text-primaryColor cursor-pointer'
							onClick={handleTC}>
							T&C
						</span>
					</div>

					<div className='flex items-center justify-center'>
						{!isSubmitted ? (
							<button
								type='submit'
								className='btn-primary'
								disabled={isSubmitting}>
								{isSubmitting ? (
									<div className='flex items-center justify-center w-full h-full'>
										<div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin'></div>
									</div>
								) : (
									"Get A Call Back Now"
								)}
							</button>
						) : (
							<div className='text-green-600 flex items-center justify-center text-md mt-5'>
								<TiTick size={24} className='text-green mr-1' />
								Our team will reach out to you shortly
							</div>
						)}
					</div>
				</form>
			</div>

			{/* Most Booked Full Body Checkups */}
			<div className='checkup-widget'>
				<div className=' max-w-sm bg-white rounded-2xl  overflow-hidden'>
					{/* Header */}

					<div className='flex items-center gap-3'>
						<h3 className='text-2xl font-bold'>
							Most Booked Full Body Check-ups
						</h3>
					</div>

					{/* Carousel Container */}
					<div
						className='relative overflow-hidden'
						onMouseEnter={() => setIsAutoPlaying(false)}
						onMouseLeave={() => setIsAutoPlaying(true)}>
						{/* Cards Container */}
						<div
							className='flex transition-transform duration-500 ease-in-out'
							style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
							{filteredProducts.map((product, index) => (
								<div key={product.id} className='w-full flex-shrink-0 p-6'>
									<div className='bg-gray-50 rounded-xl p-6 h-full border border-gray-200 hover:border-blue-300 transition-all duration-300 hover:shadow-md'>
										{/* Popular Badge */}
										{product.popular && (
											<div className='inline-flex items-center gap-1 bg-orange-100 text-orange-600 px-3 py-1 rounded-full text-sm font-medium mb-4'>
												<Zap className='w-4 h-4' />
												Most Popular
											</div>
										)}

										{/* Title */}
										<h4 className='text-xl font-bold text-gray-800 mb-4 line-height-tight'>
											{product.productTitle}
										</h4>

										{/* Test Count */}
										<div className='flex items-center gap-2 mb-4'>
											<div className='bg-blue-100 p-2 rounded-lg'>
												<TestTube className='w-5 h-5 text-blue-600' />
											</div>
											<span className='text-blue-600 font-semibold'>
												Total Tests Included: {product.parameterCovered}
											</span>
										</div>

										{/* Tests Details */}
										{/* <div className='mb-6'>
											<strong className='text-gray-700 block mb-2'>
												Tests Included:
											</strong>
											<p className='text-gray-600 text-sm leading-relaxed'>
												{product.testsIncluded}
												<span className='text-blue-500 cursor-pointer hover:underline ml-1'>
													...read more
												</span>
											</p>
										</div> */}

										{/* Pricing */}
										<div className='flex items-center gap-3 mb-6 justify-center'>
											<span className='text-3xl font-bold text-green-600'>
												{formatPrice(product.sellingPrice)}
											</span>
											<span className='text-lg text-gray-400 line-through'>
												{formatPrice(product.mrp)}
											</span>
											{/* <div className='bg-red-100 text-red-600 px-3 py-1 rounded-full text-sm font-medium flex items-center gap-1'>
												🏷️ UPTO {product.discount}% OFF
											</div> */}
										</div>

										{/* Book Now Button */}
										<div className='w-full flex items-center justify-between'>
											{order?.orderData?.some((entry) =>
												entry.items.some(
													(item) => item?.product?._id === product?._id
												)
											) ? (
												<button
													className='w-full flex items-center justify-between bg-accentColor font-normal text-[4vw] lg:text-[1vw] text-whiteColor font-normal text-[4vw] lg:text-[1vw] text-whiteColor px-5 py-2 rounded-3xl'
													onClick={() => removeProductById(product?._id)}>
													<Calendar className=' h-5 mr-3 ml-5' />
													Remove
													<ChevronRight className='w-5 h-5 ml-2 mr-3 group-hover:translate-x-1 transition-transform' />
												</button>
											) : (
												<button
													className='w-full flex items-center justify-between bg-gradient-to-r from-[#0047AF] to-[#1A67D8] font-normal text-[4vw] lg:text-[1vw] text-whiteColor px-5 py-2 rounded-3xl'
													onClick={() => addProductToCart(product)}>
													<Calendar className=' h-5 mr-3 ml-5' />
													Book Now
													<ChevronRight className='w-5 h-5 ml-2 mr-3 group-hover:translate-x-1 transition-transform' />
												</button>
											)}
										</div>
									</div>
								</div>
							))}
						</div>

						{/* Navigation Arrows */}
						<button
							onClick={prevSlide}
							className='absolute left-6 top-1/2 transform -translate-y-1/2  transition-all z-10 group'
							aria-label='Previous slide'>
							<ChevronLeft className='w-6 h-6 text-gray-600 group-hover:text-blue-600' />
						</button>

						<button
							onClick={nextSlide}
							className='absolute right-6 top-1/2 transform -translate-y-1/2  transition-all z-10 group'
							aria-label='Next slide'>
							<ChevronRight className='w-6 h-6 text-gray-600 group-hover:text-blue-600' />
						</button>
					</div>

					{/* Pagination Dots */}
					<div className='flex justify-center gap-2 bg-gray-50'>
						{filteredProducts.map((_, index) => (
							<button
								key={index}
								onClick={() => goToSlide(index)}
								className={`w-2 h-2 rounded-full transition-all duration-300 ${
									index === currentSlide
										? "bg-blue-600 w-8"
										: "bg-gray-300 hover:bg-gray-400"
								}`}
								aria-label={`Go to slide ${index + 1}`}
							/>
						))}
					</div>

					{/* Progress Indicator */}
					{/* <div className='bg-gray-200 h-1'>
						<div
							className='bg-gradient-to-r from-blue-600 to-purple-600 h-full transition-all duration-300'
							style={{
								width: `${((currentSlide + 1) / checkups.length) * 100}%`,
							}}
						/>
					</div> */}
				</div>
			</div>

			{/* Promo Cash Widget */}
			<div className='promo-widget'>
				<div className='promo-content'>
					<div className='promo-icon'>💰</div>
					<div className='promo-text'>
						<strong>Get ₹ 200 Promo Cash</strong> for extra discounts on any
						health test booking
					</div>
				</div>
				<div className='flex items-center  justify-center'>
					{!showCoupon ? (
						<button className='btn-primary' onClick={handleClaim}>
							CLAIM NOW
						</button>
					) : (
						<div className='relative flex items-center'>
							<button
								className='w-48 h-12 rounded-full border-2 border-blue-500 text-[#57636C] bg-white flex items-center justify-center gap-2 text-base font-semibold transition hover:bg-blue-50'
								onClick={handleCopy}>
								FINELABS200
								<img
									src='/assets/copy-icon.png'
									alt='copy-icon'
									className=' ml-3 w-5 h-5'
								/>
							</button>
							{copied && (
								<span className='absolute left-1/2 -translate-x-1/2 top-14  text-green rounded text-sm'>
									Code copied!
								</span>
							)}
						</div>
					)}
				</div>
			</div>

			{/* Category Selector */}
			{/* <div className='category-selector'>
				<div className='dropdown-container'>
					<button
						className='category-dropdown-btn'
						onClick={() => setCategoryDropdown(!categoryDropdown)}>
						<span>{selectedCategory || "Select Category"}</span>
						<ChevronDown
							size={20}
							className={categoryDropdown ? "rotated" : ""}
						/>
					</button>

					{categoryDropdown && (
						<div className='dropdown-menu'>
							{categories.map((category, index) => (
								<div
									key={index}
									className='dropdown-item'
									onClick={() => handleCategorySelect(category)}>
									{category}
								</div>
							))}
						</div>
					)}
				</div>
			</div> */}

			{/* Tag Cloud */}
			{/* <div className='tag-cloud-widget'>
				<h3>Tag Cloud</h3>
				<div className='tags-container'>
					<span className='tag health'>Addiction Management</span>
					<span className='tag health'>Allergy</span>
					<span className='tag health'>Anemia</span>
					<span className='tag health'>Arthritis</span>
					<span className='tag health'>Asthma</span>
					<span className='tag health'>Blood Pressure</span>
					<span className='tag health'>Cancer</span>
					<span className='tag children'>Children's Health</span>
					<span className='tag covid'>Coronavirus</span>
					<span className='tag health'>COVID-19 Diaries</span>
					<span className='tag health'>Deficiencies</span>
					<span className='tag disease'>Dengue/Malaria/Chikungunya</span>
					<span className='tag health'>Diabetes</span>
					<span className='tag disease'>Disease</span>
					<span className='tag health'>Disease Management</span>
					<span className='tag health'>Eye Problems</span>
					<span className='tag faq'>FAQ Diaries</span>
					<span className='tag fitness'>Fitness</span>
					<span className='tag general'>Health</span>
					<span className='tag health'>Heart Diseases</span>
					<span className='tag health'>Hepatitis</span>
					<span className='tag health'>Hormonal Imbalance</span>
					<span className='tag health'>Infection/Flu/Viral</span>
					<span className='tag health'>Kidney</span>
					<span className='tag lifestyle'>Lifestyle</span>
					<span className='tag lifestyle'>Lifestyle & Wellness</span>
					<span className='tag health'>Liver</span>
					<span className='tag health'>Men's Health</span>
				</div>
			</div> */}

			{/* Newsletter Signup */}

			{/* <div className='bg-white rounded-xl shadow p-6 w-full max-w-md mx-auto newsletter-widget'>
				<h3 className='text-xl font-bold mb-2'>Stay Updated</h3>
				<p className='mb-4 text-gray-600'>
					Get the latest health tips and news delivered to your inbox.
				</p>
				<form
					className='flex flex-col sm:flex-row items-center gap-2 newsletter-form'
					onSubmit={handleSubscribe}>
					<input
						type='email'
						placeholder='Enter your email'
						className='flex-1 px-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-400 transition'
						value={email}
						onChange={(e) => {
							setEmail(e.target.value);
							setStatus("");
						}}
					/>
					<button
						type='submit'
						className='bg-gradient-to-r from-blue-600 to-blue-400 text-white rounded-full px-6 py-2 font-semibold transition hover:from-blue-700 hover:to-blue-500'>
						Subscribe
					</button>
				</form>
				{status === "success" && (
					<div className='mt-3 text-green-600 font-medium'>
						Subscribed successfully!
					</div>
				)}
				{status === "error" && (
					<div className='mt-3 text-red-600 font-medium'>
						Please enter a valid email address.
					</div>
				)}
			</div> */}

			{/* <div className='newsletter-widget'>
				<h3>Stay Updated</h3>
				<p>Get the latest health tips and news delivered to your inbox.</p>
				<div className='newsletter-form'>
					<input type='email' placeholder='Enter your email' />
					<button>Subscribe</button>
				</div>
			</div> */}

			{/* Popular Posts */}
			{/* <div className='popular-posts-widget'>
				<h3>Popular Posts</h3>
				<div className='popular-post'>
					<img
						src='https://internationalintegrative.com/wp-content/uploads/2019/10/Lesser-Known-Natural-Remedies.jpg'
						alt='Popular post'
					/>
					<div className='post-content'>
						<h4>Top 10 Summer Health Tips</h4>
						<span className='post-date'>May 28, 2025</span>
					</div>
				</div>
				<div className='popular-post'>
					<img
						src='https://www.shutterstock.com/shutterstock/photos/1217647285/display_1500/stock-vector-illustrates-self-management-of-type-diabetes-includes-taking-insulin-carbohydrate-fat-and-1217647285.jpg'
						alt='Popular post'
					/>
					<div className='post-content'>
						<h4>Managing Diabetes in Hot Weather</h4>
						<span className='post-date'>May 25, 2025</span>
					</div>
				</div>
				<div className='popular-post'>
					<img
						src='https://tse2.mm.bing.net/th?id=OIP.vIPn9eveENZxAj0n3WWlfAHaEK&pid=Api&P=0&h=220'
						alt='Popular post'
					/>
					<div className='post-content'>
						<h4>Heart Health During Summer</h4>
						<span className='post-date'>May 22, 2025</span>
					</div>
				</div>
			</div> */}
			<div className='bg-white rounded-xl shadow p-6 w-full max-w-md mx-auto popular-posts-widget'>
				<h3 className='text-xl font-bold mb-4'>Popular Posts</h3>
				{popularPosts.map((post) => (
					<Link
						to={`/blog/${post.slug}`}
						key={post.slug}
						className='flex items-center mb-4 last:mb-0 popular-post group'>
						<img
							src={post.imageUrl}
							alt={post.title}
							className='w-16 h-16 rounded object-cover mr-4 border border-gray-200'
						/>
						<div className='post-content'>
							<h4 className='text-base font-semibold text-gray-800 group-hover:text-blue-700 transition'>
								{post.title}
							</h4>
							<span className='post-date text-xs text-gray-500'>
								{post.date}
							</span>
						</div>
					</Link>
				))}
			</div>

			{/* Social Media Links */}
			<div className='mb-8'>
				<h2 className='text-xl font-bold mb-4'>
					Social<span className='text-teal-500'>.</span>
				</h2>
				<div className='space-y-2'>
					{socials.map((social, index) => (
						<div
							key={index}
							onClick={() => window.open(social.url, "_blank")}
							className={`flex justify-between items-center text-white px-4 py-3 rounded cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-lg ${social.color}`}>
							<div>
								<h3 className='font-bold text-lg'>{social.name}</h3>
								<p className='text-sm'>{social.text}</p>
							</div>
							<div>{social.icon}</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
